import Page, { PageHero } from "../components/Page";
import SubNav from "../components/SubNav";
import { festival } from "../data/festival";
import styles from "./VenueInfo.module.css";

const aboutSubNav = [
  { label: "About", path: "/about", end: true },
  { label: "Venue Info", path: "/about/venue" },
  { label: "FAQ", path: "/about/faq" },
  { label: "SFMA", path: "/about/sfma" },
  { label: "Press", path: "/about/press" },
  { label: "Contact", path: "/about/contact" },
];

const sections = [
  {
    title: "Gate Hours",
    body: [
      "Thursday, July 30 — 11 AM to 6 PM (early-entry ticket required)",
      "Friday – Sunday — 9 AM to 8 PM (late arrivals park in the holding lot)",
    ],
  },
  {
    title: "Camping",
    body: [
      "Camping passes are sold separately from festival passes and are required for everyone 13 and up. Youth (13–17) are discounted; children 12 and under camp free.",
      "Note: 3-Day Festival Passes do not include camping.",
    ],
    list: [
      "Family camping — quiet hours after mainstage music until 7 AM",
      "Group camping — 8–10 people, 50' × 50' space (limited availability)",
      "Car camping — vehicles under 20', contained in 20' × 20' spaces",
      "Walk-in camping — wooded areas, risk accepted by attendee",
      "RV / Trailer — limited; tiered pricing by vehicle length",
    ],
  },
  {
    title: "Parking",
    body: [
      "Parking for non-camping vehicles is included with your festival pass. There is a designated day lot just outside the venue for guests who want to come and go.",
    ],
  },
  {
    title: "River Access",
    body: [
      "The mighty Rio Grande River — the namesake of the festival — is directly across the street from the venue at the Del Norte River Park. Note: there is no direct river access from inside the festival grounds.",
    ],
  },
  {
    title: "Dogs",
    body: [
      "Well-behaved dogs are welcome in the campground, on leash at all times. Dogs are not allowed in the festival (stage) area. Please pick up after your dog — nuisance dogs may be removed.",
    ],
  },
  {
    title: "Alcohol & Glass",
    body: [
      "No alcoholic beverages are allowed inside the fenced festival area; alcohol is permitted in the campground (no glass).",
      "Absolutely no glass on festival grounds.",
      "Beer and wine are available for purchase. Unopened water, juice, and soda are permitted, as are empty refillable containers. Zero-tolerance policy violations result in immediate removal.",
    ],
  },
];

export default function VenueInfo() {
  return (
    <>
      <PageHero
        eyebrow="Venue & camping"
        title="Venue Info"
        lede="Gates, camping options, parking, river access, dog rules, and the alcohol policy. Read it before you pack the car."
        image="/photos/festival-4.jpg"
      />
      <SubNav items={aboutSubNav} />

      <Page>
        <section className={styles.address}>
          <h2 className={styles.addressTitle}>{festival.address}</h2>
          <a
            className={styles.mapLink}
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
              festival.address
            )}`}
            target="_blank"
            rel="noopener"
          >
            Open in maps →
          </a>
        </section>

        <div className={styles.sections}>
          {sections.map((s) => (
            <section key={s.title} className={styles.section}>
              <h3 className={styles.h3}>{s.title}</h3>
              {s.body?.map((p, i) => <p key={i}>{p}</p>)}
              {s.list && (
                <ul className={styles.list}>
                  {s.list.map((li) => <li key={li}>{li}</li>)}
                </ul>
              )}
            </section>
          ))}
        </div>
      </Page>
    </>
  );
}
